import React from 'react';
import {GroupNewView} from './view';

interface GroupNewContainerProps {
  createGroup: Function;
}

export const GroupNewContainer = (props: GroupNewContainerProps) => {
  return <GroupNewView {...props} />;
};
